/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\OtherSVG\PhoneSVG.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 25th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 25th 2023 5:14:19 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function PhoneSVG(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
            <path d="M13.07,9.92c2.56-2.55,6.7-2.55,9.25,0,.19,.19,.37,.39,.53,.6l6.73,8.65c1.23,1.59,1.67,3.65,1.18,5.6l-2.05,8.21c-.22,.87,.04,1.78,.67,2.41l9.21,9.21c.63,.63,1.55,.88,2.41,.67l8.21-2.05c1.95-.49,4.02-.05,5.6,1.18l8.65,6.73c3.11,2.42,3.39,7.01,.61,9.79l-3.88,3.88c-2.77,2.77-6.92,3.99-10.79,2.63-9.9-3.48-18.88-9.15-26.29-16.57-7.43-7.41-13.09-16.39-16.57-26.28-1.36-3.86-.14-8.01,2.64-10.79l3.88-3.88Zm34.18-.04c0-1.04,.84-1.87,1.87-1.87h15c1.04,0,1.87,.84,1.87,1.87v15c0,1.04-.84,1.87-1.87,1.87s-1.87-.84-1.87-1.87V14.4l-15.55,15.55c-.73,.73-1.92,.73-2.65,0s-.73-1.92,0-2.65l15.55-15.55h-10.47c-1.04,0-1.87-.84-1.87-1.87Z"/>
        </svg>
    );
}

export default PhoneSVG;
